export enum PlaymodeType {
  SEGMENTS = 'selections',
  LIKES = 'likes',
  PLAYLIST = 'playlist',
  LOOP = 'loop',
  SEARCH_RESULT = 'search-result',
  SHUFFLE = 'shuffle',
}

export const DefaultPlaymodeType = PlaymodeType.PLAYLIST